import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertCircleIcon, ArrowRightIcon } from 'lucide-react';
import { CountdownTimer } from '../components/CountdownTimer';
import { CTAButton } from '../components/CTAButton';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { EbookMockup } from '../components/EbookMockup';
import { BenefitItem } from '../components/BenefitItem';
import { Footer } from '../components/Footer';
export function Upsell1Page() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleAccept = () => {
    navigate('/upsell-2');
  };
  const handleDecline = () => {
    navigate('/upsell-2');
  };
  return <div className="min-h-screen bg-wellness-cream flex flex-col" data-id="element-259">
      {/* Top Warning Bar */}
      <div className="bg-wellness-red text-white text-center py-3 px-4 font-bold tracking-wide flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4" data-id="element-260">
        <AlertCircleIcon className="w-5 h-5 animate-pulse" data-id="element-261" />
        <span data-id="element-262">ESPERA - Oferta Especial Solo Para Ti</span>
        <CountdownTimer initialSeconds={600} className="bg-white/20 border-none text-white py-1" data-id="element-263" />
      </div>

      <div className="flex-grow py-12 px-4" data-id="element-264">
        <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-wellness-darkBeige" data-id="element-265">
          <div className="p-8 md:p-12" data-id="element-266">
            <div className="text-center mb-10" data-id="element-267">
              <h1 className="text-3xl md:text-4xl font-bold mb-4 text-wellness-dark" data-id="element-268">
                ¡Complementa tu programa con 30 Postres Sin Azúcar!
              </h1>
              <p className="text-xl text-wellness-body" data-id="element-269">
                Disfruta de postres deliciosos sin culpa, sin azúcar refinada y
                sin inflamar tu cuerpo.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-12" data-id="element-270">
              <div className="flex justify-center" data-id="element-271">
                <EbookMockup title="Postres Sin Azúcar" subtitle="30 Recetas" variant="secondary" className="scale-110" data-id="element-272" />
              </div>

              <div data-id="element-273">
                <h3 className="text-2xl font-bold mb-6" data-id="element-274">
                  ¿Por qué necesitas esto?
                </h3>
                <div className="space-y-4 mb-8" data-id="element-275">
                  <BenefitItem text="Satisface tus antojos dulces de forma saludable" data-id="element-276" />
                  <BenefitItem text="Cero azúcar refinada, endulzados naturalmente" data-id="element-277" />
                  <BenefitItem text="Fáciles de preparar en menos de 20 minutos" data-id="element-278" />
                  <BenefitItem text="Perfectos para compartir con toda la familia" data-id="element-279" />
                  <BenefitItem text="No interrumpen tu proceso antiinflamatorio" data-id="element-280" />
                </div>

                <div className="bg-wellness-beige p-6 rounded-2xl text-center" data-id="element-281">
                  <p className="text-wellness-body mb-2" data-id="element-282">
                    Precio Normal: <span className="line-through" data-id="element-283">€27</span>
                  </p>
                  <p className="text-xl mb-1" data-id="element-284">Oferta Única Hoy:</p>
                  <p className="text-5xl font-bold text-wellness-primary mb-6" data-id="element-285">
                    €9.90
                  </p>

                  <CTAButton onClick={handleAccept} className="w-full mb-4" data-id="element-286">
                    ¡Sí, Quiero Esta Oferta!
                  </CTAButton>

                  <button onClick={handleDecline} className="text-wellness-body hover:text-wellness-dark underline text-sm transition-colors" data-id="element-287">
                    No gracias, continuar sin los postres
                  </button>
                </div>
              </div>
            </div>

            <GuaranteeSection data-id="element-288" />
          </div>
        </div>
      </div>

      <Footer data-id="element-289" />
    </div>;
}